
import {
  defineComponent, ref, watch,
} from 'vue';
import { FButton, FIcon } from '../..';
import { ModalProps } from '../props';

export default defineComponent({
  components: {
    FButton,
    FIcon,
  },
  props: ModalProps,
  emits: [
    /** v-model */
    'update:visible',
    /** 点击取消 */
    'cancel',
    /** 点击确定 */
    'ok',
  ],
  setup(props, ctx) {
    /** 是否可见 */
    const isVisible = ref(props.visible ?? false);
    const setIsVisible = (value: boolean) => {
      if (value === isVisible.value) {
        return;
      }
      isVisible.value = value;
      ctx.emit('update:visible', value);
    };

    watch(
      () => props.visible,
      () => {
        isVisible.value = props.visible;
      },
    );

    /** “取消”按钮回调 */
    const handleCancel = () => {
      ctx.emit('cancel');
      setIsVisible(false);
    };

    /** “确定”按钮回调 */
    const handleOk = () => {
      ctx.emit('ok');
      setIsVisible(false);
    };

    /** 点击遮罩回调 */
    const handleClickMask = () => {
      if (props.maskClosable) {
        handleCancel();
      }
    };

    return {
      isVisible,
      setIsVisible,
      handleCancel,
      handleOk,
      handleClickMask,
    };
  },
});
